<template>
  <container-list-extend title="Stock">
    <template v-slot:title>
      <div class="p-1 rounded-top d-flex flex-row align-items-center flex-grow-1">
        <description-from-list :value="stock.article_id" :data="articles"></description-from-list>
      </div>
      <div class="text-muted pl-2 pr-2 pl-md-3 pr-md-3 d-flex align-items-center">
        <small>{{stock.description}} {{stock.quantite}}</small>
      </div>
    </template>
    <template v-slot:form>
      <base-form
        @click="updateStock(stock)"
        deleteBtn
        @delete="deleteStock(stock)"
        :statut="statut"
        :loading="loading"
      >
        <base-form-row row>
          <base-select inputText="Article" v-model.number="stock.article_id" :options="articles"></base-select>
        </base-form-row>
        <base-form-row row>
          <BaseSlideNumber
            v-model.number="stock.quantite"
            text="Quantité"
            :max="100"
            :min="0"
            :errors="feedback.quantite"
          ></BaseSlideNumber>
        </base-form-row>
        <base-form-row row>
          <base-input v-model="stock.commentaire" inputText="Commentaire"></base-input>
        </base-form-row>
      </base-form>
    </template>
  </container-list-extend>
</template>
<script>
import { mapActions } from "vuex";
import { errHandler } from "@/helpers.js";
import { mapGetters } from "vuex";

//import BaseIcon from "@/components/bases/Icon.vue";
import ContainerListExtend from "@/components/containers/ContainerListExtend.vue";
import BaseForm from "@/components/bases/Form.vue";
import { mapMultiRowFields } from "vuex-map-fields";
import DescriptionFromList from "@/components/bases/DescriptionFromList";

import BaseFormRow from "@/components/bases/FormRow.vue";
import BaseInput from "@/components/bases/Input.vue";
import BaseSelect from "@/components/bases/Select.vue";
import BaseSlideNumber from "@/components/bases/SlideNumber.vue";

export default {
  name: "StocksItem",
  components: {
    //BaseIcon,
    ContainerListExtend,
    BaseForm,
    BaseFormRow,
    BaseInput,
    BaseSelect,
    DescriptionFromList,
    BaseSlideNumber
  },
  data() {
    return {
      feedback: {},
      loading: false,
      statut: null
    };
  },
  props: ["stock"],
  computed: {
    ...mapMultiRowFields("materiel", ["articles"]),
    ...mapGetters({
      data: "materiel/data"
    })
  },
  methods: {
    ...mapActions({
      _updateStock: "materiel/updateStock",
      _deleteStock: "materiel/deleteStock"
    }),
    updateStock: function(stock) {
      this.feedback = {};
      this.loading = true;
      this._updateStock(stock)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    deleteStock: function(stock) {
      if (!window.confirm("Confirmer la suppression de l'élément ?")) return null
      this.feedback = {};
      this.loading = true;
      this._deleteStock(stock)
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
<style lang="css">
</style>